export const OnlineNewPaymentPageTemplate = {
    slots: ['SlbNewPaymentContainerSlot'],
};